import { StatePreV8, StateV8 } from './8_migrate_unfall_produkt_on_zaehlstuecke.interface';

export const migrateUnfallProduktOnZaehlstuecke = (
  previousState: StatePreV8,
  newVersion: number,
): StateV8 => {
  const newState = {
    ...previousState,
    version: newVersion,
    unfallZaehlstueck: previousState.unfallProdukt,
  };
  delete newState.unfallProdukt;
  return newState;
};
